import { render, staticRenderFns } from "./KaojiMemberList.vue?vue&type=template&id=2bdde974&scoped=true&"
import script from "./KaojiMemberList.vue?vue&type=script&lang=js&"
export * from "./KaojiMemberList.vue?vue&type=script&lang=js&"
import style0 from "./KaojiMemberList.vue?vue&type=style&index=0&id=2bdde974&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdde974",
  null
  
)

export default component.exports